module.exports = __webpack_public_path__ + "img/logo_newway_dark.d6204889.svg";